import CircularProgress from "@mui/joy/CircularProgress";
import { SxProps } from "@mui/joy/styles/types";
import Box from "@mui/system/Box";

interface Props {
  loaderSize?: "sm" | "md" | "lg";
  sx?: SxProps;
}

const Loader = ({ loaderSize, sx }: Props) => {
  return (
    <Box
      sx={[
        {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <CircularProgress size={loaderSize} />
    </Box>
  );
};
export default Loader;
